import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../routes";
import globalUtils from "../../utils/globalUtils";

const InactiveAccount = () => {
  const navigate = useNavigate();

  useEffect(() => {
    globalUtils.removeTokens();
  }, []);

  const handleClick = () => {
    navigate(ROUTES.PATHS.LOGIN, { replace: true });
  };

  return (
    <div className="default-text space-y-1 grid place-content-center h-screen text-center text-river-bed">
      <div className="text-heading21">The account is inactive.</div>
      <div className="px-2 text-subheading16">
        Please contact with Clap Admin to activate your account.
      </div>
      <div className=" text-subheading16 flex gap-x-1.5 justify-center">
        <div>Try going back to</div>
        <div
          className="underline cursor-pointer text-primary"
          onClick={handleClick}
          aria-hidden="true"
        >
          Login
        </div>
      </div>
    </div>
  );
};

export default InactiveAccount;
